import { render, staticRenderFns } from "./Chek.vue?vue&type=template&id=98713450&scoped=true"
import script from "./Chek.vue?vue&type=script&lang=js"
export * from "./Chek.vue?vue&type=script&lang=js"
import style0 from "./Chek.vue?vue&type=style&index=0&id=98713450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98713450",
  null
  
)

export default component.exports